<template>
    <!--热点词汇[[-->
    <div class="radar-main g-laboratory-padding hot-words-main hot-video-main">
        <div class="hot-words-block">
            <radar-query-box @search="doSearch" ref="raderQueryBox"></radar-query-box>

            <!--热词条[[-->
            <div class="g-laboratory-analysis-item"  v-if="paginationConf.total>0">
                <p class="hot-word">
                    <strong>为您查到{{ paginationConf.total }}个相关结果</strong>
                </p>
            </div>
            <!--热词条]]-->

            <!--热词条[[-->
            <div class="g-laboratory-analysis-item"  style="display: block;" v-else>
                <p class="hot-word">
                    没有找到相关结果
                </p>
                <!--<a class="g-laboratory-a back-btn" href="javascript:;">返回</a>-->
            </div>
            <!--热词条]]-->
        </div>


        <div class="hot-words-block sort-wrap without-line" v-loading="loading">
            <div class="f-clearfix select-item" v-if="paginationConf.total>0">
                <div class="f-fl select-item-main" @click="changeListOrder('hot')">
                    <a href="javascript:;" :class="params.order===0 ? 'select-on' : 'select-off'">最热排序
                    </a>
                </div>
                <div class="f-fl select-item-main" @click="changeListOrder('new')">
                    <a href="javascript:;"  :class="params.order===1 ? 'select-on' : 'select-off'">最新排序
                    </a>
                </div>
                <!--<div class="f-fr select-item-right">-->
                    <!--已为您找到40个结果-->
                <!--</div>-->
            </div>


            <!--结果显示区域[[-->
            <div class="result-show-area">
                <div class="hot-words-lists" v-for="(item,key) in hotTagData" :key="item">
                    <div class="f-clearfix hot-words-title-wrap">
                        <p class="f-fl hot-words-title">
                            <i class="ico ico-label-floor">{{ key+1 }}</i>
                            <span>{{ item.token }}</span>
                            <a class="see-hot-words-analysis" href="javascript:;" @click="goToWordAnalyze(item)">查看该热词分析</a>
                        </p>
                        <p class="f-fr hot-number">
                            <i class="ico ico-heat">&nbsp;</i>
                            {{item.hotrank}}
                        </p>
                    </div>
                    <ul class="words-lists">
                        <li class="words-descri" v-for="article in item.article" :key="article">
                            <a :href="article.url" target="_blank">{{ article.title}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!--结果显示区域]]-->
        </div>
        <!--无结果显示图标[[-->
        <div class="result-show-area no-data-show" style="display: none;">
            <div class="no-data-pic"></div>
        </div>
        <!--无结果显示图标]]-->
        <!-- 分页[[ -->
        <pagination
                v-if="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager">
        </pagination>
        <!-- 分页]] -->
    </div>
    <!--热点词汇]]-->
</template>
<style lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/laboratory/radar.scss';
    .select-item-main a{
        display: block;
        height: 30px;
        line-height: 30px;
        border: 1px solid #FD7E28;
        font-size: 14px;
        text-align: center;
        border-radius: 2px;
        transition: all .3s;
        width: 5rem;
        margin-left: 3px;
    }
    .select-on{
        background: #FD7E28;
        color: #fff;
    }
    .select-off{
        background: #fff;
        color: #FD7E28;
    }
    .radar .hot-words-main .hot-words-block .hot-words-lists .hot-words-title{
        width: 20rem;
    }
</style>
<script>
import radarQueryBox from './radar_query_box';
import pagination from 'Components/v4/pagination/pagination_v4';
import {
    TrendHotTagData
} from 'Services/getData.js';
export default {
    data () {
        return {
            paginationConf: {
                total: 0,
                pageSize: 3
            },
            params: {
                pageIndex: 0,
                pageSize: 3,
                time: 3,
                order: 0
            },
            queryCount: 0, // 查询结果
            hotTagData: [],
            loading: true
        }
    },
    components: {
        radarQueryBox, pagination
    },
    mounted () {
        this.getHotTagList();
    },
    methods: {
        goToWordAnalyze(item) {
            this.$router.history.push({
                name: 'v4-laboratory-radar-detail', params: item
            })
        },
        changeListOrder(order){
            if(order=='new'){
                this.params.order = 1;
            }else {
                this.params.order = 0;
            }
            this.getHotTagList();
        },
        async getHotTagList (){
            let param = this.params;
            this.loading = true;
            let response = await TrendHotTagData(param);
            if(response.status == 200){
                let data = response.data;
                if (data.code == 0) {
                    this.hotTagData = data.data.data;
                    this.paginationConf.total = data.data.count;
                }
            }
            this.loading = false;
        },
        pageChange (param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex-1; // 发送给接口的字段
            this.getHotTagList();
        },
        doSearch(param) {
            if(this.paginationConf.total > 0){
                this.$refs.pager.first();
            }
            this.params.pageIndex = 0;
            this.params.time = param.time;
            this.params.classId = param.classId;
            this.params.word = param.searchContent;
            this.getHotTagList();
        }
    }
}
</script>
